import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetProductionRecipeLinkHealthQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.ProductionRecipeLinkHealthRowFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProductionRecipeLinkHealthRowSortInput> | Types.ProductionRecipeLinkHealthRowSortInput>;
}>;


export type GetProductionRecipeLinkHealthQuery = { __typename?: 'Query', productionRecipeLinkHealth?: { __typename?: 'ProductionRecipeLinkHealthConnection', totalCount: number, edges?: Array<{ __typename?: 'ProductionRecipeLinkHealthEdge', cursor: string, node: { __typename?: 'ProductionRecipeLinkHealthRow', issue: Types.ProductionRecipeLinkHealthIssue, productionRecipeId: string, productionRecipeVariationId: string, recipeProductionCatalogId: string, recipeCatalogGenus: string, recipeCatalogSeries: string, recipeCatalogColor: string, recipeCategoryCode: string, linkProductionCatalogId: string, linkProductionCategoryId: string, linkCatalogGenus: string, linkCatalogSeries: string, linkCatalogColor: string, linkCategoryCode: string, linkedProductionRecipeId?: string | null, linkedRecipeStatus?: Types.ProductionRecipeStatus | null } }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };


export const GetProductionRecipeLinkHealthDocument = new TypedDocumentString(`
    query GetProductionRecipeLinkHealth($first: Int, $after: String, $last: Int, $before: String, $where: ProductionRecipeLinkHealthRowFilterInput, $order: [ProductionRecipeLinkHealthRowSortInput!]) {
  productionRecipeLinkHealth(
    first: $first
    after: $after
    last: $last
    before: $before
    where: $where
    order: $order
  ) {
    edges {
      cursor
      node {
        issue
        productionRecipeId
        productionRecipeVariationId
        recipeProductionCatalogId
        recipeCatalogGenus
        recipeCatalogSeries
        recipeCatalogColor
        recipeCategoryCode
        linkProductionCatalogId
        linkProductionCategoryId
        linkCatalogGenus
        linkCatalogSeries
        linkCatalogColor
        linkCategoryCode
        linkedProductionRecipeId
        linkedRecipeStatus
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetProductionRecipeLinkHealth: build.query<GetProductionRecipeLinkHealthQuery, GetProductionRecipeLinkHealthQueryVariables | void>({
      query: (variables) => ({ document: GetProductionRecipeLinkHealthDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetProductionRecipeLinkHealthQuery, useLazyGetProductionRecipeLinkHealthQuery } = injectedRtkApi;
